import { NavigationCardItem } from "@/components/navigation-card-item/navigation-card-item";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { VideoTutorialButton } from "@/components/video-tutorial-button/video-tutorial-button";
import { NavigationItem } from "@/config/navigation/types";
import { ModuleTileDecoration } from "./module-tile-decoration";

interface ModuleTileProps {
  item: NavigationItem;
}

export function ModuleTile({ item }: ModuleTileProps) {
  const Icon = item.icon;
  const directChildren: NonNullable<typeof item.children> = [];
  const childGroups: NonNullable<typeof item.children> = [];

  for (const child of item.children ?? []) {
    if (!child.children || child.children.length === 0) {
      directChildren.push(child);
      continue;
    }
    childGroups.push(child);
  }

  return (
    <Card className="h-full overflow-hidden">
      <ModuleTileDecoration item={item} />
      <CardHeader className="relative">
        <CardTitle className="flex items-center gap-2.5 leading-tight">
          {Icon && (
            <span className="bg-primary/10 text-primary flex h-9 w-9 shrink-0 items-center justify-center rounded-lg [&_svg]:h-5 [&_svg]:w-5">
              <Icon />
            </span>
          )}
          <span className="truncate">{item.title()}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="relative space-y-4">
        <div className="flex flex-wrap gap-2">
          {item.videoTutorialUrl && <VideoTutorialButton url={item.videoTutorialUrl} />}
          {!item.children && <NavigationCardItem item={item} />}
          {directChildren.map((child) => (
            <NavigationCardItem key={child.id} item={child} />
          ))}
        </div>

        {childGroups.map((group) => {
          const GroupIcon = group.icon;

          return (
            <div key={group.id} className="space-y-2">
              <div className="text-muted-foreground flex items-center gap-1.5 text-sm font-medium">
                {GroupIcon && <GroupIcon className="h-4 w-4" />}
                {group.title()}
              </div>
              <div className="flex flex-wrap gap-2">
                {group.children?.map((child) => (
                  <NavigationCardItem key={child.id} item={child} />
                ))}
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
